import { t } from "ttag";

import { displayNameForColumn } from "metabase/value-formatting";
import {
  type VisualizationDefinition,
  columnSettings,
  getDefaultSize,
  getMinSize,
  tableColumnSettings,
} from "metabase/viz-core";

export const OBJECT_DETAIL_DEFINITION: VisualizationDefinition = {
  getUiName() {
    return t`Detail`;
  },
  identifier: "object",
  iconName: "document",
  get noun() {
    return t`object`;
  },
  minSize: getMinSize("object"),
  defaultSize: getDefaultSize("object"),
  hidden: false,
  canSavePng: false,
  disableClickBehavior: true,
  settings: {
    ...columnSettings({ getHidden: () => true }),
    ...tableColumnSettings({ isShowingDetailsOnlyColumns: true }),
  },
  columnSettings: () => {
    return {
      column_title: {
        title: t`Column title`,
        widget: "input",
        getDefault: (column) => displayNameForColumn(column),
      },
      click_behavior: {},

      // Makes sure `column_settings` doesn't omit these settings,
      // so they can be used for formatting
      view_as: { getHidden: () => true },
      link_text: { getHidden: () => true },
      link_url: { getHidden: () => true },
    };
  },
  isSensible: () => true,
  checkRenderable: () => true,
};
